import type { FrameVariant } from "@/types/onboarding";

export const defaultCopy = {
  body_copy_1: "Body copy 1 example",
  body_copy_2: "Body copy 2 example",
  bullet_point_1: "Bullet point 1 example",
  bullet_point_2: "Bullet point 2 example",
  bullet_point_3: "Bullet point 3 example",
  call_to_action_1: "Call to action 1 example",
  call_to_action_2: "Call to action 2 example",
  call_to_action_3: "Call to action 3 example",
  headline: "Headline example",
  subheader_1: "Subheader 1 example",
  subheader_2: "Subheader 2 example",
};

/**
 * Default tile variants to use for creative generation
 * These represent common email template types that will get AI-generated content
 */
export const DEFAULT_FRAME_VARIANTS: FrameVariant[] = [
  { key: "BROWSE_CLASSIC" },
  { key: "MAGIC_EXPERIMENTAL" },
  { key: "PRICE_DROP_CLASSIC" },
  { key: "CART_EXPERIMENTAL" },
  { key: "POST_PURCHASE_TRANSACTIONAL" },
];
